import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingSpinner = ({ size = 'lg', text = 'Loading...' }) => {
  return (
    <div className="loading-spinner">
      <div className="text-center">
        <Spinner animation="border" variant="light" size={size} />
        <div className="mt-3 text-white">
          <i className="fas fa-compass me-2"></i>
          {text}
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner; 